module.exports = __webpack_public_path__ + "static/media/content-submission-heading@2x.181b0ef8.png";